import React from 'react'
import Head from 'next/head'
import { publicUrl } from '@chegg-wt/core/utils/url'
import { HeadTags } from '@chegg-wt/core/types/core'

const AppHeadTags: React.FC<HeadTags> = ({ metaTags }) => (
  <Head>
    {metaTags.map((tag) => (
      <meta key={tag.name} name={tag.name} content={tag.content} />
    ))}
    <link
      rel="shortcut icon"
      type="image/x-icon"
      href={publicUrl('/static/favicon.ico')}
    />
    <script src="https://apis.google.com/js/api.js" />
    <script
      dangerouslySetInnerHTML={{
        __html: `
        // Adds dataLayer to window to store events until GTM script is added
      if (typeof window !== 'undefined') {
        window.dataLayer = window.dataLayer || [];
      }
    `,
      }}
    />
  </Head>
)

export default AppHeadTags
